import { CreateConfig }                                           from "features/workflow/CreateConfigComponent";
import { CMSApiResponse }                                      from "framework/http/CMSApiClient";
import { RunContextApp }                                          from "framework/RCApp";
import { GetValues }                                              from "types/cms/frontendTypes";

export const ServerConfigsAPI = {

  getServerConfigs : async (rc: RunContextApp, pilotId : string, configTypes : string[]) => {

    const response = await rc.cmsApiClient.post('/global/apiServerConfigs', { 
      pilotId, configTypes
    })
    
    return response
  },

  createServerConfig : async (rc: RunContextApp, pilotId : string, systemNodeDocId : string, config : CreateConfig) 
      : Promise<CMSApiResponse<GetValues<"api::config.config">>> => {

    const serverConfigCollection = rc.cmsApiClient.getClient().collection("configs")
    
    const resp = await serverConfigCollection.create({
      pilotId : pilotId,
      configType : config.configType,
      key : config.configKey,
      label : config.label,
      description : config.description,
      systemNodes : {
        connect : [{ documentId : systemNodeDocId }]
      }
    })

    return resp as any
  }
}